export enum AriaSort {
  None = "none",
  Ascending = "ascending",
  Descending = "descending",
  Other = "other",
}

export interface SearchCriteria {
  columnId: number;
  filterValues: string;
  priority?: number;
}
export interface GridColumnHeader {
  id: string;
  title: string;
  filterOn?: number;
  isSearchable?: boolean;
  isSortable?: boolean;
  isSorted?: boolean;
  isAscending?: boolean;
  isFilterd?: boolean;
  isRowHeader?: boolean;
  template?: any;
}
import { AriaDescriber } from "@angular/cdk/a11y";
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  AfterViewInit,
} from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { MatPaginator } from "@angular/material/paginator";
import { buffer } from "rxjs/operators";
import { DataSharingService } from "src/app/services/data-sharing.service";
import { DomSanitizer } from '@angular/platform-browser';
import { MatCheckbox } from "@angular/material/checkbox";

@Component({
    selector: "app-table",
    templateUrl: "./table.component.html",
    styleUrls: ["./table.component.scss"],
    standalone: false
})
export class TableComponent implements OnInit, OnChanges {
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChildren("sortTh") sortElement: QueryList<any>;
  @ViewChild('selectAll') selectAll: MatCheckbox;


  @Input() isRowClickable = false;
  @Input() columnHeader = [];
  @Input() columnRowData = [];
  @Input() filtersOnDashboard = [];
  @Input() showUtils = false;
  @Input() pageLength = 0;
  @Input() pageSize: number = 10;
  @Input() showCheckbox = false;
  @Input() resetTable = false;
  @Input() variant: string;
  @Input() noDataMsg: string;
  @Input() isColumnLevelFilter: boolean;
  @Input() showTotalPages;
  @Input() showColumnLevelFilter = false;
  @Input() showLoader = false;
  @Input() myUserGroup = false;
  @Output() selectedRowEvent = new EventEmitter();
  @Output() paginationInfo = new EventEmitter();
  @Output() sortedColumnData = new EventEmitter();
  @Output() filterClick = new EventEmitter();
  @Output() closeFilterOverlay = new EventEmitter();
  @Output() filterData = new EventEmitter();
  @Output() checkOrUncheckSelected = new EventEmitter();

  columnRowDataBackup = [];
  splicedData = [];
  defaultSort = true;
  display = "none";
  searchLabel: any;
  searchText = "";
  pageIndex: number = 0;
  lowValue: number = 0;
  highValue: number = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  selectedPageIndex = 0;

  topPosition: string;
  leftPosition: string;
  objPosition: { top: any; left: any };
  showFilterPopUp = false;
  showResetFilter = false;
  selectedHeaderIndex = null;
  priority = 0;
  // searchDataResult = [];
  searchDataResult: SearchCriteria[] = [];
  showPaginator = false;
  activeElement: HTMLElement;
  selectedRows: any = [];

  columnId: null;
  isSelectedAll: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private dataSharingService: DataSharingService, // private searchService: SearchService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'icon-filter',
      sanitizer.bypassSecurityTrustResourceUrl('assets/images/filter.svg'));
      iconRegistry.addSvgIcon(
        'icon-filter-fill',
        sanitizer.bypassSecurityTrustResourceUrl('assets/images/icon-filter-fill.svg'));
      iconRegistry.addSvgIcon(
          'ChevronUp',
          sanitizer.bypassSecurityTrustResourceUrl('assets/images/ChevronUp.svg'));
      iconRegistry.addSvgIcon(
            'ChevronDown',
            sanitizer.bypassSecurityTrustResourceUrl('assets/images/ChevronDown.svg'));
  }

  ngOnChanges(simplechange: SimpleChanges): void {
    this.columnRowDataBackup = [...this.columnRowData];

    if (this.showCheckbox) {
      this.updateColumnRowData();
    }
    if (this.selectedPageIndex > 0) {
      this.pageSize = this.selectedPageIndex;
    }
    if (simplechange.pageLength) {
      this.showPaginator = false;
      this.paginationPageSet();
      this.pageLength = simplechange["pageLength"]["currentValue"];
      setTimeout(() => {
        this.showPaginator = true;
      }, 0);
    }

    if (this.resetTable) {
      this.searchDataResult = [];
    }

    this.selectedRows.forEach(ele => {
      this.columnRowData.forEach(obj => {
         obj.isSelected = ele.isSelected;
      })
    });
    setTimeout(() => {
      if(this.selectAll){
        this.selectAll.writeValue(this.isAllSelected());
      }
    }, 0)
  }

  ngOnInit(): void {
    this.columnRowDataBackup = [...this.columnRowData];
    if(this.isAllSelected()){
      this.isSelectedAll = true;
    }
  }

  getData(data, colName) {
    if (typeof data[colName] === "object" && data[colName] !== null) {
      return this.getData(data[colName], colName);
    }
    return data[colName];
    // return "";
  }

  dynamicContent(col) {
    try {
      return col.template.templateContent;
    } catch (e) {
      return false;
    }
  }
  sortHeader(e, header, index) {
    e.stopPropagation();
    if (header.isSortable) {

      const sortData = {
        sort: { columnId: header.filterOn, isAscending: !header.isAscending },
        searchData: this.searchDataResult,
      };
      this.sortedColumnData.emit(sortData);
    }
  }

  onFilterClick(header, index, el) {
    this.filterClick.emit(header);
    this.columnId = header;
    this.selectedHeaderIndex = Number(index);
    this.searchLabel = header;
    this.showFilter(header, index);
    this.activeElement = el;
  }

  showFilter(header, index) {
    // this.filterClick.emit(header)
    if (header.isSearchable) {
      const srdArr = this.sortElement.toArray();
      if (this.sortElement && srdArr.length) {
        const parentPosition =
          srdArr[index].nativeElement.getBoundingClientRect();
        const lefPos = parentPosition.right;
        const topPos = parentPosition.bottom;
        const windowWidth = document.documentElement.clientWidth;

        const bufferTop = -2;
        // const bufferLeft = 131 ;
        const bufferLeft = 131 - 26;

        const windowTop = window.scrollY + bufferTop;

        const minLeft = 20;
        const maxLeft = windowWidth - 215 - minLeft;
        const naturalLeft = lefPos - bufferLeft;
        let calculatedLeft: number;
        calculatedLeft = Math.min(naturalLeft, maxLeft);
        calculatedLeft = Math.max(minLeft, calculatedLeft);

        this.topPosition = windowTop + topPos + "px";
        this.leftPosition = calculatedLeft + "px";

        this.objPosition = { top: this.topPosition, left: this.leftPosition };

        this.showFilterPopUp = true;
      }
    }
  }

  selectedRowDetails(data) {
   // console.log(dat)
    if (this.isRowClickable) {
      console.log(data)
      this.selectedRowEvent.emit(data);
    }
  }

 
  paginationPageSet() {
    if (this.paginator) {
      this.paginator.firstPage();
     // this.paginator.length = this.columnRowData.length;
    }
  }

  applyColumnFilter(values: string) {
    const valueArr = values?.split(',');
    valueArr.forEach((ele, index) => {
      if(typeof ele === 'string' && ele.trim().length === 0){
        valueArr[index] = null;
      }
    })
    const columnId = this.columnHeader[this.selectedHeaderIndex].filterOn;
    this.showFilterPopUp = false;
    this.filterData.emit({
      filterValues: valueArr.toString(),
      columnId: columnId,
    });
    this.selectedHeaderIndex = null;
  }

  closeFilter(e) {
    this.showFilterPopUp = false;
    this.closeFilterOverlay.emit("");
    this.selectedHeaderIndex = null;
    this.activeElement.focus();
    this.activeElement = null;
  }

  tableSearch(data: Array<any>) {
    // this.priority = this.priority+1;
    const dataColumnId = data[0].columnId;
    const columnExist = this.searchDataResult.findIndex(
      (el) => el.columnId === dataColumnId
    );
    if (columnExist > -1) {
      this.searchDataResult.splice(columnExist, 1);
    } else {
      this.priority = this.priority + 1;
    }
    data.forEach((el) => {
      if (!el["priority"]) {
        el["priority"] = this.priority;
      }

      // only reinclude this column if there is a search value
      if (el["filterValues"]) {
        this.searchDataResult.push(el);
      }
    });
    this.dataSharingService.shareFilterColumnData(this.searchDataResult);

    this.columnHeader[this.selectedHeaderIndex].isFilterd =
      this.searchDataResult.some((result) => result.columnId === dataColumnId)
        ? true
        : false;
    this.closeFilter("");
  }

  resetFilterHeader() {
    this.columnHeader.forEach((header) => {
      header["isFilterd"] = false;
    });
    this.columnHeader = [...this.columnHeader];
    this.showResetFilter = false;
  }

  resetGrid() {
    this.resetFilterHeader();
    this.columnRowData = [...this.columnRowDataBackup];
  }

  getPaginatorData(event) {
    let pageData: any;
    if (event.pageSize !== this.pageSize) {
      this.pageSize = event.pageSize;
      this.selectedPageIndex = this.pageSize;
      // pageData = {pageNumber : event.pageIndex + 1, pageSize:this.pageSize, searchFilter : this.searchDataResult}
      this.showPaginator = false;
      this.paginationPageSet();

      //Added for search grid the event emitter
      pageData = {
        pageNumber: event.pageIndex + 1,
        pageSize: this.pageSize,
      //  searchFilter: this.searchDataResult,
      };
      this.paginationInfo.emit(pageData);
      setTimeout(() => {
        this.showPaginator = true;
      }, 0);
    } else {
      this.pageSize = event.pageSize;
      this.selectedPageIndex = this.pageSize;
      pageData = {
        pageNumber: event.pageIndex + 1,
        pageSize: this.pageSize,
     //   searchFilter: this.searchDataResult,
      };
      this.paginationInfo.emit(pageData);
    }
  }

  calculatePadding(i: number): string {
    if (i === 0) return "1.25rem";
    return "0.4rem";
  }

  isDashboardTable() {
    return (
      this.variant.includes("all-smth-view") ||
      this.variant.includes("agregate-view")
    );
  }

  isFiltered(header: GridColumnHeader) {
    return header.isFilterd;
  }

  getFilterBtnClass(header: GridColumnHeader, i: number): string {
    if (header.isFilterd || i === this.selectedHeaderIndex) {
      return "nr-icon-btn-dark-blue";
    }
    return "nr-icon-btn-white";
  }

  getAriaSort(header: GridColumnHeader): string {
    if (header.isSorted) {
      return header.isAscending ? AriaSort.Ascending : AriaSort.Descending;
    }
    return AriaSort.None;
  }

  getSortIcon(header: GridColumnHeader): string {
    if (header.isSorted) {
      return header.isAscending ? "ChevronUp" : "ChevronDown";
    }
    return "";
  }
  getSortRIcon(header: GridColumnHeader): string {
    if (header.isSorted) {
      return header.isAscending ? "ChevronDown" : "ChevronUp";
    }
    return "";
  }

  updateColumnRowData() {
    this.columnRowData.forEach((ele) => {
      ele['isSelected'] = false;
    });
  }

  setValue(event, i) {

    if (i > -1) {
      this.columnRowData[i].isSelected = event.checked;
      this.columnRowData = [...this.columnRowData]
      this.updateSelectedRowData(this.columnRowData[i]);
    }
    this.selectAll.writeValue(this.isAllSelected());
  }

  selectDeselectAll(event) {
      this.columnRowData.forEach((ele) => {
      ele.isSelected = event.checked;
      this.updateSelectedRowData(ele);
    });

  }

  isAllSelected() {
    return this.columnRowData.every((x) => x.isSelected === true);
  }

  updateSelectedRowData(selectedRow) {
    if (selectedRow.isSelected) {
      if (this.selectedRows.filter(ele => ele.id == selectedRow.id)) {
        this.selectedRows.push(selectedRow);
      }
    } else {
      this.selectedRows = this.selectedRows.filter(ele => {
        return ele.id != selectedRow.id;
      })
    }
   this.checkUncheckSelected(this.selectedRows);
  }

  checkUncheckSelected(data) {
    this.checkOrUncheckSelected.emit(data);
  }
}
